module.exports = __webpack_public_path__ + "img/s-hsl.8b25adf0.png";